import { defineMessages } from 'react-intl'

const scope = `procurify.spending-cards.page`

export default defineMessages({
  cardholderAccountPageTitle: {
    id: `${scope}.cardholderAccountPageTitle`,
    defaultMessage: 'Cardholder account',
  },
  cardholderAccountSetupPageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Set up account',
  },
  cardholderAccountEditPageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Edit account',
  },
  cardholderAccountVerifyPageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Verify cardholder',
  },
  cardManagementPageTitle: {
    id: `${scope}.cardManagementPageTitle`,
    defaultMessage: 'Manage cards',
  },
  transactionReconciliationPageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Spending card reconciliation',
  },
  cardManagementDetailsPageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Card details',
  },
  requestVirtualCardPageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Request virtual card',
  },
  virtualCardsPageTitle: {
    id: `${scope}.virtualCardsPageTitle`,
    defaultMessage: 'Virtual cards',
  },
})
